var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 133,
    viewBox: "0 0 132 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12836",
    "data-name": "Group 12836",
    transform: "translate(907 -7575)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_388",
    "data-name": "Ellipse 388",
    cx: 66,
    cy: 66.5,
    rx: 66,
    ry: 66.5,
    transform: "translate(-907 7575)",
    fill: "#fdeebe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eye_1_",
    "data-name": "eye (1)",
    transform: "translate(-878.323 7610.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4395",
    "data-name": "Path 4395",
    d: "M31.9,9A32.148,32.148,0,0,0,2,29.387a32.12,32.12,0,0,0,59.8,0A32.134,32.134,0,0,0,31.9,9Zm0,33.978A13.591,13.591,0,1,1,45.492,29.387,13.6,13.6,0,0,1,31.9,42.978Zm0-21.746a8.155,8.155,0,1,0,8.155,8.155A8.161,8.161,0,0,0,31.9,21.232Z",
    transform: "translate(5.323 1.953)",
    fill: "#4c5b71"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/EyeIcon.953216bda151a04df11fd7a616f4ed12.svg";
export { ForwardRef as ReactComponent };